<template>
  <div class="activity-detali">
    <el-dialog :visible.sync="show" width="590px" :show-close="false" :before-close="onbalck" :modal-append-to-body="false">
      <div slot="title" class="alertHeader dialogHeader">
        <img loading="lazy" class="dialogClose-header-img cursorPoint" v-lazy="require('../../static/image/pn/login-close2.png')" @click="onbalck" />
        <div class="alertTitle dialogTitles">{{$t('signIn.actDet')}}</div>
      </div>
      <div class="conent">
        <el-scrollbar style="height:4.5rem;padding-right:2px">
          <div class="text" v-html="intro">
            <!-- <br><div>
                      即日起会员于元宝娱乐投注捕鱼游戏，按照北京时间计算每天完成相对的有效投注即可获得相应的彩金连续7天不间断嘉奖最高88元。
                  </div><br><br>
                  <div>
                       例：会员于第一天存款100元在捕鱼游戏有效投注6000，即可申请18元，会员于第二天存款100元在捕鱼游戏有效投注6000，
                    即可申请28元；以此类推。会员每天存款100元完成有效投注6000，连续签到7天不间断，即可直接获得嘉奖88元，连续签到7天继续签
                    到将重新开始签到计算。
                  </div><br><br>

                   <p>申请方式：</p> 
                   <p>符合条件的会员请在指定北京时间内登录【603yb.com 】进行申请 ，否则逾期则视为自动放弃优惠。</p>
                   <br><br>
                   <p> 活动规则：</p>
                   <p>         
                        1、每个会员每日只可申请一次（计算时间为北京时间），逾期视为放弃。
                        2、当日签到彩金必须在次日24小时内进行申请，所赠送的彩金和返水需娱乐捕鱼游戏且完成一倍有效投注即可提款。 
                        3、此活动由元宝娱乐特为玩家而设，如发现任何团体或个人，以不诚实方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余或会员等级的权利。
                        4、为避免对以上文字的理解差异，元宝娱乐保留对此活动的最终解释权；以及在未通知的情况下修改、终止此活动的权利。
                        5.参与该优惠，即表示您同意《优惠规则与条款》。
                    </p> -->

          </div>
        </el-scrollbar>
      </div>

    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      intro: ""
    }
  },
  methods: {
    onbalck() {
      this.show = false;
    }
  }
}
</script>

<style lang="scss">
.activity-detali {
  // @import "./eldialog.scss";
  .conent {
    .text {
      color: #2d2b4d;
      font-size: 14px;
      text-align: left;
    }
    img {
      width: auto;
    }
  }

  .el-dialog__wrapper {
    overflow: hidden;
  }
  .image-slots {
    height: auto;
  }
}
</style>
